// extracted by mini-css-extract-plugin
module.exports = {"LiveStatus":"index-module_LiveStatus_2962s"};